module.exports = __webpack_public_path__ + "static/media/progress_bar_2_active.0525b512.svg";